import { DRAWDATA } from "../../actions/portal/";

export default function(state = [], action) {
  switch (action.type) {
    case DRAWDATA:
      return [...state, action.payload];
    default:
  }
  return state;
}
